import KiteLoader from './KiteLoader';

export default KiteLoader;
